import { confirm, ConfirmConfigDefaultRender } from 'components/modals/confirm'

interface RemoveWithOptionalConfirmOptions extends Omit<ConfirmConfigDefaultRender, 'onConfirm'> {
  shouldAskConfirmation: boolean
  onRemove: () => void
}

const defaultConfig: Pick<ConfirmConfigDefaultRender, 'type' | 'size' | 'confirmLabel'> = {
  type: 'danger',
  size: 'small',
  confirmLabel: 'Excluir',
}

export async function removeWithOptionalConfirm(config: RemoveWithOptionalConfirmOptions): Promise<boolean> {
  const { shouldAskConfirmation, onRemove, ...rest } = { ...defaultConfig, ...config }

  if (!shouldAskConfirmation) {
    onRemove()
    return true
  }

  const confirmed = await confirm(rest)()
  if (confirmed) onRemove()
  return confirmed
}
